import { render, staticRenderFns } from "./IssueDetail.vue?vue&type=template&id=9551fe02&scoped=true&"
import script from "./IssueDetail.vue?vue&type=script&lang=js&"
export * from "./IssueDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9551fe02",
  null
  
)

export default component.exports